<template>
  <div>
    <table class="tabla-pagos">
      <tr>
        <th>ID</th>
        <th>DNI</th>
        <th>Jugador</th>
        <th>Temporada</th>
        <th>Contrato</th>
        <th>Fecha Inicio</th>
        <th>Fecha Fin</th>
        <th>Concepto</th>
        <th>Tipo de Condición</th>
        <th>Desc. Tipo de Cambio</th>
        <th>Tipo de Importe</th>
        <th>Importe</th>
        <th>Moneda</th>
        <th>Tope</th>
        <th>Frecuencia</th>
        <th>Primer Vencimiento</th>
        <th>Cuotas</th>
        <th>Siguiente Vencimiento</th>
        <th>Observaciones</th>
        <th>Estado</th>
        <th>Motivo</th>
        <th>Fecha de Cierre</th>
        <th>Tipo de Cambio</th>
      </tr>
      <tr v-for="(condicion, index) in condiciones" :key="index">
        <td v-for="(diff, index) in condicion.diffs" :key="index" v-html="diff">
          {{diff}}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>

export default {
  props: {
    condiciones: Array
  }
}
</script>
<style scoped>
.tabla-pagos {
  width: 100%;
}
.tabla-pagos tr:hover {
  background-color: rgb(200, 200, 200);
}
.tabla-pagos th {
  padding-top: 1em;
  border-bottom: 1px solid #bbb;
}
.tabla-pagos td {
  text-align: center;
  border-bottom: 1px solid #bbb;
}
</style>
